<u-dc-associate-search
  [searchResult]="searchResult$ | async"
  (associateSearchClicked)="onAssociateSearchClicked($event)"
  (backClicked)="onBackClicked()"
  (closeClicked)="onCloseClicked()"
></u-dc-associate-search>
